import { jsx as s } from "react/jsx-runtime";
import { c as a } from "../../index-3527e6f9.js";
import { c as r } from "../../utils-933d6383.js";
const n = a("", {
  variants: {
    variant: {
      t1_18semibold: "tw-text-lg tw-font-semibold",
      t2_16bold: "tw-text-md tw-font-bold",
      t3_16semibold: "tw-text-base tw-font-semibold",
      t4_16medium: "tw-text-base tw-font-medium",
      b1_16regular: "tw-text-base tw-font-normal",
      b2_14semibold: "tw-text-sm tw-font-semibold",
      b3_14medium: "tw-text-sm tw-font-medium",
      b4_14regular: "tw-text-sm tw-font-normal"
    }
  }
}), l = ({
  className: t,
  children: o,
  variant: e,
  ...m
}) => /* @__PURE__ */ s(
  "text",
  {
    className: r("", n({ variant: e }), t),
    ...m,
    children: o
  }
);
export {
  l as Typography,
  n as typographyVariants
};
